import { render, staticRenderFns } from "./header-mobile.vue?vue&type=template&id=77b85732&"
import script from "./header-mobile.vue?vue&type=script&lang=ts&"
export * from "./header-mobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77b85732')) {
      api.createRecord('77b85732', component.options)
    } else {
      api.reload('77b85732', component.options)
    }
    module.hot.accept("./header-mobile.vue?vue&type=template&id=77b85732&", function () {
      api.rerender('77b85732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/header/header-mobile.vue"
export default component.exports